/**
 * Category levels
 *
 * @type {{}}
 */
export const levels = {
  one: 'one',
  two: 'two',
  three: 'three'
};
export const levelsTitle = {
  [levels.one]: 'Раздел',
  [levels.two]: 'Подраздел',
  [levels.three]: 'Категория'
};